import { ActivatedRoute, Router } from '@angular/router';
import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  PublicService
} from 'src/app/api/public.service';
import {
  Station
} from 'src/app/models/api_models/station';
import {
  LeafletMapComponent
} from 'src/app/leaflet-map/leaflet-map.component';

@Component({
  selector: 'app-autopartage',
  templateUrl: './autopartage.component.html',
  styleUrls: ['./autopartage.component.scss']
})
export class AutopartageComponent implements OnInit {
  @ViewChild('leafletMap') leafletMapChild: LeafletMapComponent;

  private _currentGps: [number, number] = [.6311634, 3.0599573];
  get currentGps() {
    return this._currentGps;
  }
  set currentGps(currentGps) {
    this._currentGps = currentGps;
  }
  
  private _mapStationSelected : Station;
  get mapStationSelected() : Station {
    return this._mapStationSelected;
  }
  set mapStationSelected(mapStationSelected) {
    this._mapStationSelected = mapStationSelected;
  }



  // Stations autopartages envoyées sur le block leaflet et la selection des station du formulaire 
  private _stationList: Station[] = [];
  get stationList() {
    return this._stationList;
  }
  set stationList(stationList) {
    this._stationList = stationList;
  }

  private _stationSelected: Station = null;
  get stationSelected() {
    return this._stationSelected;
  }
  set stationSelected(stationSelected) {
    this._stationSelected = stationSelected;
  }


  stationChangedHandler(stationFocus: Station) {


   


    // console.log(stationFocus);
    this._currentGps = [stationFocus.latitude, stationFocus.longitude];
    this._mapStationSelected = stationFocus;

     console.log(stationFocus);
    this.router.navigate(['/'], { queryParams: { page: 34 } });




  }

  constructor(public route: ActivatedRoute, private router: Router, private publicApiService: PublicService) {this.getUrl()}

  isMontDesAvaloirs = false;

  ApiInit() {

    if(location.pathname === "/velo"){
      var service = 10
    }else{
      var service = 1
    }

    this.publicApiService.getStationList(service).subscribe(
      reponse => {
        this._stationList = reponse;
        // console.warn(this._stationList);
        
        if (this._stationList.length > 0) {
          this._stationSelected = this._stationList[0];
        }
        // console.log(this.stationList);

      }
    );
  }

  fragment : String;

  ngOnInit() {
    this.stationList = [];
    this.ApiInit();
    this.route.fragment.subscribe(fragment => { 
          this.fragment = fragment;  
          //  console.log("auto auth :",fragment);
          this.scrollHtag()});
    
  }

  scrollHtag() {
    if(this.fragment) {
        // document.querySelector('#' + this.fragment).scrollIntoView(false);
      window.location.href = "#comment-ca-marche"
    } 
}


  // get url 
  getUrl(){
    let host = location.host
    if(host ===  `mont-des-avaloirs.clem.mobi`){
      this.isMontDesAvaloirs = true
    }else {
      this.isMontDesAvaloirs = false
    }
  }

}
